import { useState } from "react";
import ArrowLink from "components/atoms/arrowLink/index.jsx";
import Button from "components/atoms/button/index.jsx";
import ValidatePromotionCode from "components/molecules/promotionCode/Validate";
import VehicleDataItem from "components/atoms/vehicleDataItem/index.jsx";
import VehicleDetailActions from "components/molecules/vehicleDetailActions/index.jsx";
import { number, currency, getDiscountAmount } from "helpers/format.js";
import findPromotionForVehicle from "helpers/findPromotionForVehicle";

import "./styles.scss";

function promotionSupportsVehicle(promotion, vehicle) {
  return findPromotionForVehicle(promotion, vehicle) ? true : false;
}

const VehicleDetail = ({ vehicle, availablePromotion }) => {
  const [hasCoupon, setHasCoupon] = useState(false);
  const [promotion, setPromotion] = useState(null);
  const [defaultPromotionCode, setDefaultPromotionCode] = useState("");

  return (
    <div className="vehicleDetail">
      <div className="container">
        <div className="content">
          <div className="vehicleData">
            <div>
              <VehicleDataItem
                label={vehicle.brand}
                text={vehicle.name}
                type="big"
                style="vehicle"
              />
            </div>
            <div className="row">
              <div className="colFirst">
                <VehicleDataItem
                  label="Kilometraje"
                  text={number(vehicle.km)}
                  type="medium"
                  style="vehicle"
                />
              </div>
              <div className="colLast">
                <VehicleDataItem
                  label="Año"
                  text={vehicle.year}
                  type="medium"
                  style="vehicle"
                />
              </div>
            </div>
            <div className="row">
              <div className="colFirst">
                <VehicleDataItem
                  label="Combustible"
                  text={vehicle.engine}
                  type="medium"
                  style="vehicle"
                />
              </div>
              <div className="colLast">
                <VehicleDataItem
                  label="Color"
                  text={vehicle.color}
                  type="medium"
                  style="vehicle"
                />
              </div>
            </div>
            {vehicle.equipment && (
              <div className="row">
                <div className="colLarge">
                  <VehicleDataItem
                    label="Equipamiento"
                    text={vehicle.equipment}
                    type="medium"
                    style="vehicle"
                  />
                </div>
              </div>
            )}
            {vehicle.state && (
              <div className="row">
                <div className="colLarge">
                  <VehicleDataItem
                    label="Estado"
                    text={vehicle.state}
                    type="medium"
                    style="vehicle"
                  />
                </div>
              </div>
            )}
            {vehicle.location != null && vehicle.location != "MENDOZA" && (
              <div className="row">
                <div className="colFirst">
                  <VehicleDataItem
                    label="Stock"
                    text="San Rafael"
                    type="medium"
                    style="vehicle"
                  />
                </div>
              </div>
            )}
          </div>
          <div className="priceData">
            <div>
              <VehicleDataItem
                label="Precio final"
                text={currency(
                  vehicle.full_price - getDiscountAmount(vehicle, promotion)
                )}
                type="big"
                discount={getDiscountAmount(vehicle, promotion)}
                style="price"
              />
            </div>
            <div className="row">
              <div className="colFirst">
                <VehicleDataItem
                  label="Precio"
                  text={currency(vehicle.price)}
                  type="medium"
                  style="price"
                />
              </div>
              <div className="colLast">
                <VehicleDataItem
                  label="Entrega"
                  text={currency(parseFloat(vehicle.delivery_price))}
                  type="medium"
                  style="price"
                />
              </div>
            </div>
            <div className="row">
              <div className="colFirst">
                <VehicleDataItem
                  label="Transferencia"
                  text={currency(vehicle.transfer_price)}
                  type="medium"
                  style="price"
                />
              </div>
              {promotion && (
                <div className="colLast">
                  <VehicleDataItem
                    label="Descuento"
                    text={`- ${currency(
                      getDiscountAmount(vehicle, promotion)
                    )}`}
                    type="medium"
                    style="price"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="coupon">
        <div className="container">
          <div className="content discountBlock">
            {!promotion &&
              promotionSupportsVehicle(availablePromotion, vehicle) && (
                <>
                  <div className="availableDiscounts">
                    <h4>Descuentos disponibles</h4>
                    <div className="discountItem">
                      <Button
                        onClick={() => {
                          setHasCoupon(true);
                          setDefaultPromotionCode(availablePromotion.code);
                        }}
                        buttonText={"Aplicar: " + availablePromotion.title}
                        style={"white"}
                      ></Button>
                      <br />
                      <br />
                    </div>
                    {!hasCoupon && (
                      <ArrowLink
                        onClick={() => {
                          setHasCoupon(true);
                          setDefaultPromotionCode("");
                        }}
                      >
                        {!promotion &&
                          promotionSupportsVehicle(
                            availablePromotion,
                            vehicle
                          ) && <>Tengo otro cupón de descuento</>}
                        {!promotion &&
                          !promotionSupportsVehicle(
                            availablePromotion,
                            vehicle
                          ) && <>Tengo un cupón de descuento</>}
                      </ArrowLink>
                    )}
                  </div>
                </>
              )}

            {hasCoupon && (
              <ValidatePromotionCode
                withCopy
                defaultCode={defaultPromotionCode}
                vehicle={vehicle}
                onSuccess={(data) => setPromotion(data)}
                key={defaultPromotionCode}
              />
            )}
          </div>
        </div>
      </div>
      <VehicleDetailActions vehicle={vehicle} />
    </div>
  );
};

export default VehicleDetail;
